import * as React from "react";
import { EditorTools, EditorToolsSettings } from "@progress/kendo-react-editor";


// Creates custom FontSize tool.
const CustomFontName = EditorTools.createStyleDropDownList(EditorToolsSettings.fontName);
const CustomFontNameTool = (props) => {
  return (
    <CustomFontName
      {...props}
      style={{
        width: "100px",
        ...props.style,
      }}
      popupSettings={{
        width: "210px",
      }}
    />
  );
};



export { CustomFontNameTool };